import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Music2 } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    const run = async () => {
      if (hasProcessed.current) return;
      hasProcessed.current = true;
      const params = new URLSearchParams(location.search);
      const code = params.get("code");
      if (!code) { navigate("/"); return; }
      try {
        const { data } = await api.post("/auth/google-callback", { code });
        window.history.replaceState(null, "", "/dashboard");
        await refresh();
        if (!data.account?.onboarding_complete) {
          navigate("/onboarding", { replace: true });
        } else {
          navigate("/dashboard", { replace: true });
        }
      } catch (e) {
        console.error(e);
        navigate("/", { replace: true });
      }
    };
    run();
  }, [location, navigate, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#FCFCFD]">
      <div className="text-center">
        <div className="w-12 h-12 rounded-xl bg-[#0F172A] text-white grid place-items-center mx-auto animate-pulse">
          <Music2 className="w-5 h-5" />
        </div>
        <p className="mt-4 text-slate-600 text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
